import React, { PureComponent } from "react";
import { Col, Modal } from "antd";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ChartRenderer from "../components/ChartRenderer";
import Dashboard from "../components/Dashboard";
import DashboardItem from "../components/DashboardItem";
import { Multiselect } from "multiselect-react-dropdown";
// import Radio from "@material-ui/core/Radio";
// import RadioGroup from "@material-ui/core/RadioGroup";

import { Radio } from 'antd';


import TextField from "@material-ui/core/TextField";
import { SaveOutlined, FilterOutlined, SearchOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import { Button, Tooltip } from 'antd';
import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import Tour from 'reactour'
import 'antd/dist/antd.css';

const { Meta } = Card;

let savedViewContainer = [];
let savedViewContainerObj = JSON.parse(localStorage.getItem("savedViewContainer"));

const stateData = require("../data/dataglobal");



const steps = [
  {
    selector: '.save-funnel',
    content: '<a href="#">Toggle over all filter section',
  },
  {
    selector: '.save-view',
    content: 'Toggle saved views section',
  }
  // ,
  // {
  //   selector: '.savedView',
  //   content: 'Save current filter to view later'
  // }
]




class DashboardPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = stateData;
    this.storedFilter1 = savedViewContainerObj;
    this.showHide = this.showHide.bind(this);
    this.style = {
      chips: {
        background: "red",
      },
      searchBox: {
        "border": "none",
        // "border-bottom": "1px solid #efefef",
        // "border-radius": "0px",
      },
    };
  }




  onSelectAllOption = (selectedList, selectedItem) => {

    console.log('===selectedItem===', selectedItem.catName);
    console.log('===selectedList===', selectedList);


    //selectedList


    this.setState({
      selectedAllValue: selectedList,
    });

    if (selectedItem.catName === "Facility") {
      this.setState({
        facilityList: [...this.state.facilityList, selectedItem.value],
      });
    }

    if (selectedItem.catName === "Bpcategory") {
      this.setState({
        bPCategoryList: [...this.state.bPCategoryList, selectedItem.value],
      });
    }

    // Customer name



    if (selectedItem.catName === "Customer name") {
      this.setState({
        bpNameList: [...this.state.bpNameList, selectedItem.value],
        selectedValueBPName: selectedList,
      });
    }

    // Line of business 
    if (selectedItem.catName === "Line of business") {
      this.setState({
        lineOfBusinessList: [...this.state.lineOfBusinessList, selectedItem.value],
        // selectedValueLineOfBusiness: selectedList,
      });
    }

    // product category 
    if (selectedItem.catName === "Product category") {
      this.setState({
        productCategoryList: [...this.state.productCategoryList, selectedItem.value],
        //    selectedValueProductCategory: selectedList,
      });
    }

    // Document type
    if (selectedItem.catName === "Document type") {
      this.setState({
        doctypeList: [...this.state.doctypeList, selectedItem.value],
        // selectedValueDoctype: selectedList,
      });
    }


    // Service Plan
    if (selectedItem.catName === "Service plan") {
      this.setState({
        serviceList: [...this.state.serviceList, selectedItem.value],
        selectedServiceValue: selectedList,
      });
    }




  };


  onRemoveAllOption = (selectedList, removedItem) => {
    this.setState({ selectedAllValue: selectedList, });

    if (removedItem.catName === 'Facility') { this.setState({ facilityList: this.state.facilityList.filter((item) => item !== removedItem.value), }); }
    if (removedItem.catName === 'Bpcategory') { this.setState({ bPCategoryList: this.state.bPCategoryList.filter((item) => item !== removedItem.value), }); }
    // Customer name
    if (removedItem.catName === 'Customer name') { this.setState({ bpNameList: this.state.bpNameList.filter((item) => item !== removedItem.value), }); }
    // Line of Business 
    if (removedItem.catName === 'Line of business') {
      this.setState({
        lineOfBusinessList: this.state.lineOfBusinessList.filter(
          (item) => item !== removedItem.value
        ),
        //       selectedValueLineOfBusiness: selectedList,
      });
    }

    // Product category 
    if (removedItem.catName === 'Product category') {
      this.setState({
        productCategoryList: this.state.productCategoryList.filter(
          (item) => item !== removedItem.value
        ),
        // selectedValueProductCategory: selectedList,
      });
    }

    // Document type 
    if (removedItem.catName === 'Document type') {
      this.setState({
        doctypeList: this.state.doctypeList.filter(
          (item) => item !== removedItem.value
        ),
        // selectedValueDoctype: selectedList,
      });
    }
    // Service plan 
    if (removedItem.catName === 'Service plan') { this.setState({ serviceList: this.state.serviceList.filter((item) => item !== removedItem.value), selectedServiceValue: selectedList, }); }
  };
  onSelectTimeFilter = (selectedList, selectedItem) => { this.setState({ timeDimension: selectedItem.value, selectedTimeFilterValue: selectedList }); };
  onRemoveTimeFilter = (selectedList, removedItem) => { this.setState({ timeDimension: this.state.timeDimension.filter((item) => item !== removedItem.value), }); };
  // onSelectDateRange
  onSelectGranularity = (selectedList, selectedItem) => { this.setState({ granularityList: selectedItem.value, selectedGranularityList: selectedList }); };
  onRemoveGranularity = (selectedList, removedItem) => { this.setState({ granularityList: this.state.timeDimension.filter((item) => item !== removedItem.value), }); };
  onSelectDateRange = (selectedList, selectedItem) => { this.setState({ dateRangeList: selectedItem.value, selectedDateRangeList: selectedList }); };
  onRemoveDateRange = (selectedList, removedItem) => { this.setState({ dateRangeList: this.state.timeDimension.filter((item) => item !== removedItem.value), }); };
  handleChartFilter = (event) => { this.setState({ displayFilterValue: event.target.value, }); };
  handleFilterOption = (event) => {
    var assignState = this.state; var objectAllFilterArray = []; var filterSeelctionOption = event.target.value;
    this.setState({ selectFilterValue: event.target.value });
    if (event.target.value === 'all') { this.setState({ objectAllFilterArray: objectAllFilterArray.concat(assignState.objectAllFAArray, assignState.objectAllCCArray, assignState.objectAllCuArray, assignState.objectAllSPArray, assignState.objectAllDOCArray, assignState.objectAllPCArray, assignState.objectAllLBArray) }); }
    if (filterSeelctionOption === 'facility') { this.setState({ objectAllFilterArray: this.state.objectAllFAArray }); }
    if (filterSeelctionOption === 'Bpcategory') { this.setState({ objectAllFilterArray: this.state.objectAllCCArray }); }
    if (filterSeelctionOption === 'CustomerName') { this.setState({ objectAllFilterArray: this.state.objectAllCuArray }); }
    if (filterSeelctionOption === 'lineOfBusiness') { this.setState({ objectAllFilterArray: this.state.objectAllLBArray }); }
    if (filterSeelctionOption === 'productCategory') { this.setState({ objectAllFilterArray: this.state.objectAllPCArray }); }
    if (filterSeelctionOption === 'documentType') { this.setState({ objectAllFilterArray: this.state.objectAllDOCArray }); }
    if (filterSeelctionOption === 'servicePlan') { this.setState({ objectAllFilterArray: this.state.objectAllSPArray }); }
    // myArray = myArray.filter(function (obj) {
    // return obj.field !== 'money';
    // }); 
  }
  showHide = () => { const { showSavedViews } = this.state; if (this.state.showSavedViews) { } else { this.setState({ showFilters: false, showSavedViews: !showSavedViews }); } };
  showHideFilters = () => { this.setState({ editMode: false, filterId: '', filterName: '', filterDescription: '', filtersTitleName: 'Filter' }); if (this.state.showFilters) { } else { const { showFilters } = this.state; this.setState({ showSavedViews: false, showFilters: !showFilters }); } };
  showHideOverAllFilters = () => { const { showHideOverAllFilters } = this.state; this.setState({ show: false, showHideOverAllFilters: !showHideOverAllFilters }); };

  showHideLabel = () => {
    const { showCreateSavedView } = this.state;
    if (!this.state.showCreateSavedView) {
      this.setState({ showCreateSavedView: !showCreateSavedView });
    }
    this.setState({ visible: true });
  };


  deleteStateView = (index, id, event) => {
    savedViewContainer = JSON.parse(localStorage.getItem("savedViewContainer"));
    savedViewContainer = savedViewContainer.filter(item => item.filterId !== id);
    localStorage.setItem("savedViewContainer", JSON.stringify(savedViewContainer));
    this.setState({
      storedFilters: savedViewContainer
    });
    console.log('After Delete', savedViewContainer);
    toast.error('Saved view filter Removed!');
  }

  editStateView = (index, id, event) => {
    this.setState({   editMode: true, }); 
    this.displayStateView(index);
    // eslint-disable-next-line react/no-direct-mutation-state
    this.state.showFilters = true;
    // eslint-disable-next-line react/no-direct-mutation-state
    this.state.showSavedViews = false;
    let savedViewContainers = JSON.parse(localStorage.getItem("savedViewContainer"));
    const savedViewContainer = savedViewContainers.filter(savedViewContainer => savedViewContainer.filterId === id)[0];
    this.setState({
      filterId: savedViewContainer.filterId, //selectedView.filterId,
      filterName: savedViewContainer.name, //selectedView.name,
      filterDescription: savedViewContainer.value, //selectedView.value
      filtersTitleName: 'Editing ' + savedViewContainer.name
    });
  }
  handleTextInput = (fieldName) => (e) => {
    this.setState({ [fieldName]: [e.target.value] });
    // this.setState({ filterName: e.target.value });
  }
  handleStateView = (editMode, paramFilterId) => (event) => {
    let filterName = this.state.filterName;
    let filterDescription = this.state.filterDescription;
    console.log('this.state.filterName', this.state.filterName)
    let formattedArray = {
      //'filterId': paramFilterId,
      'filterId': 1,
      'name': filterName,
      'value': filterDescription,
      'stateSavedView': {
        'facilityList': this.state.facilityList,
        'bPCategoryList': this.state.bPCategoryList,
        'bpNameList': this.state.bpNameList,
        'lineOfBusinessList': this.state.lineOfBusinessList,
        'productCategoryList': this.state.productCategoryList,
        'doctypeList': this.state.doctypeList,
        'serviceList': this.state.serviceList,
        'timeDimension': this.state.timeDimension,
        'dateRangeList': this.state.dateRangeList,
        'granularityList': this.state.granularityList, 
        'selectedTimeFilterValue': this.state.selectedTimeFilterValue,
        'selectedDateRangeList': this.state.selectedDateRangeList,
        'selectedGranularityList': this.state.selectedGranularityList,
        'selectedAllValue': this.state.selectedAllValue,
        'displayFilterValue': this.state.displayFilterValue
      }
    }




    if ((filterName && filterDescription) !== '') { 
      if ((localStorage.getItem("savedViewContainer")) !== null) {
        savedViewContainer = JSON.parse(localStorage.getItem("savedViewContainer"));
        if (editMode) {
          //let filterId = document.getElementById("filterId");
          let savedViewFilterForEdit = [];

          savedViewFilterForEdit.push({
            'filterId': paramFilterId,
            'name': filterName,
            'value': filterDescription,
            'stateSavedView': {
              'facilityList': this.state.facilityList,
              'bPCategoryList': this.state.bPCategoryList,
              'bpNameList': this.state.bpNameList,
              'lineOfBusinessList': this.state.lineOfBusinessList,
              'productCategoryList': this.state.productCategoryList,
              'doctypeList': this.state.doctypeList,
              'serviceList': this.state.serviceList,
              'timeDimension': this.state.timeDimension,
              'dateRangeList': this.state.dateRangeList,
              'granularityList': this.state.granularityList, 
              'selectedTimeFilterValue': this.state.selectedTimeFilterValue,
              'selectedDateRangeList': this.state.selectedDateRangeList,
              'selectedGranularityList': this.state.selectedGranularityList,
              'selectedAllValue': this.state.selectedAllValue,
              'displayFilterValue': this.state.displayFilterValue
            }
          });
          console.log('Before Edit', savedViewFilterForEdit);
          savedViewContainer = savedViewContainer.map(obj => savedViewFilterForEdit.find(o => o.filterId === obj.filterId) || obj);
          localStorage.setItem("savedViewContainer", JSON.stringify(savedViewContainer));
          // eslint-disable-next-line react/no-direct-mutation-state
          this.state.storedFilters = savedViewContainer;
          console.log('After Edit', savedViewContainer);
          toast.success(filterName + ' - View modifed!');
        } else {
          savedViewContainer.push(formattedArray);
          toast.success('View saved with the name - ' + filterName);
        }

        localStorage.setItem("savedViewContainer", JSON.stringify(savedViewContainer));
          // eslint-disable-next-line react/no-direct-mutation-state
        this.state.storedFilters = savedViewContainer;

      } else {
        // savedViewContainer.push({ 'name': filterName.value, 'value': filterDescription.value, 'state': this.state });
        savedViewContainer.push(formattedArray);

        console.log('savedViewContainer', savedViewContainer);
        localStorage.setItem("savedViewContainer", JSON.stringify(savedViewContainer));
          // eslint-disable-next-line react/no-direct-mutation-state
        this.state.storedFilters = savedViewContainer;
        toast.success('View saved with the name - ' + filterName);
      }
      this.setState({ showCreateSavedView: false });
    }



  };

  displayStateView = (savedFilterIndex, event) => {
    var selectedView = JSON.parse(localStorage.getItem("savedViewContainer"));
    selectedView = selectedView[savedFilterIndex].stateSavedView;
    this.setState({
      filterId: selectedView.filterId,
      filterName: selectedView.name,
      filterDescription: selectedView.value,
      facilityList: selectedView.facilityList,
      bPCategoryList: selectedView.bPCategoryList,
      bpNameList: selectedView.bpNameList,
      lineOfBusinessList: selectedView.lineOfBusinessList,
      productCategoryList: selectedView.productCategoryList,
      doctypeList: selectedView.doctypeList,
      serviceList: selectedView.serviceList,

      timeDimension: selectedView.timeDimension,
      dateRangeList: selectedView.dateRangeList,
      granularityList: selectedView.granularityList,

      // selectedFacilityValue: selectedView.selectedFacilityValue,
      // selectedValueBPCategory: selectedView.selectedValueBPCategory,
      // selectedValueBPName: selectedView.selectedValueBPName,
      // selectedValueLineOfBusiness: selectedView.selectedValueLineOfBusiness,
      // selectedValueProductCategory: selectedView.selectedValueProductCategory,
      // selectedValueDoctype: selectedView.selectedValueDoctype,
      // selectedServiceValue: selectedView.selectedServiceValue,

      selectedTimeFilterValue: selectedView.selectedTimeFilterValue,
      selectedDateRangeList: selectedView.selectedDateRangeList,
      selectedGranularityList: selectedView.selectedGranularityList,
      selectedAllValue: selectedView.selectedAllValue,
      displayFilterValue: selectedView.displayFilterValue

    });
  };

  closeTour = () => {
    this.setState({ isTourOpen: false });
  };

  openTour = () => {
    this.setState({ isTourOpen: true });
  };



  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false, visible: false });
    }, 3000);
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };




  render() {

    let query;
    let displayfilterchart, displayfilterchartHours = "number";
    let displayfiltername = "No of Completed Work Orders";
    let workOrderFilter = [];
    let salesOrderFilter = [];

    if (this.state.facilityList.length >= 1) {
      workOrderFilter.push({
        dimension: "AdOrg.facility",
        operator: "equals",
        values: this.state.facilityList,
      })
      salesOrderFilter.push({
        dimension: "AdOrg.facility",
        operator: "equals",
        values: this.state.facilityList,
      })
    }

    if (this.state.bPCategoryList.length >= 1) {
      workOrderFilter.push({
        dimension: "CBpartnerCategory.bp_cat_name",
        operator: "contains",
        values: this.state.bPCategoryList,
      }
      )
      salesOrderFilter.push({
        dimension: "CBpartnerCategory.bp_cat_name",
        operator: "contains",
        values: this.state.bPCategoryList,
      }
      )
    }

    if (this.state.bpNameList.length >= 1) {
      workOrderFilter.push({
        dimension: "CBpartner.name",
        operator: "contains",
        values: this.state.bpNameList,
      }
      )
      salesOrderFilter.push({
        dimension: "CBpartner.name",
        operator: "contains",
        values: this.state.bpNameList,
      }
      )
    }
    if (this.state.lineOfBusinessList.length >= 1) {
      workOrderFilter.push({
        dimension: "ContainerCategory.LineOfBusiness",
        operator: "contains",
        values: this.state.lineOfBusinessList,
      }
      )
      salesOrderFilter.push({
        dimension: "ContainerCategory.LineOfBusiness",
        operator: "contains",
        values: this.state.lineOfBusinessList,
      }
      )
    }

    // { console.log('this.state.productCategoryList.length', this.state.productCategoryList.length) }
    if (this.state.productCategoryList.length >= 1) {
      workOrderFilter.push({
        // dimension: "CDoctypeForPriority.doctype_name",
        dimension: "ProductCategory.productCategoryName",
        operator: "contains",
        values: this.state.productCategoryList,
      }
      )
      salesOrderFilter.push({
        // dimension: "CDoctypeForPriority.doctype_name",
        dimension: "ProductCategory.productCategoryName",
        operator: "contains",
        values: this.state.productCategoryList,
      }
      )
    }


    if (this.state.doctypeList.length >= 1) {
      workOrderFilter.push({
        // dimension: "CDoctypeForPriority.doctype_name",
        dimension: "CDoctypeForPriority.doctype_name",
        operator: "contains",
        values: this.state.doctypeList,
      }
      )
      salesOrderFilter.push({
        // dimension: "CDoctypeForPriority.doctype_name",
        dimension: "CDoctype.doctype_name",
        operator: "contains",
        values: this.state.doctypeList,
      }
      )
    }
    if (this.state.serviceList.length >= 1) {
      workOrderFilter.push({
        dimension: "ContainerPlan.contmng_plan_name",
        operator: "contains",
        values: this.state.serviceList,
      }
      )
    }

    let timeDimentionValue = [
      {
        "dimension": 'WorkOrder.start_date', // "Work Order Enddate",
        "granularity": this.state.granularityList, // "year",
        "dateRange": this.state.dateRangeList
      }];

    let timeDimentionValueForSO = [
      {
        "dimension": 'SOrder.so_created', // "Work Order Enddate",
        "granularity": this.state.granularityList, // "year",
        "dateRange": this.state.dateRangeList
      }];


    let workOrderCount, workOrderLateCount, workOrderLatePercentage,
      workOrderAvgSLT, workOrderAvgDuration, cancelledOrderCount, cancelledOrderPercentage = {};
    let displayFilterDimention = [];

    if (this.state.displayFilterValue !== "workorders") {
      workOrderCount = {
        "WorkOrder.completed_count": "desc",
      };
      workOrderLateCount = {
        "WorkOrder.late_count": "desc",
      };
      workOrderLatePercentage = {
        "WorkOrder.late_percent": "desc",
      };
      workOrderAvgSLT = {
        "WorkOrder.avg_work_order_lead_hours": "desc",
      };
      workOrderAvgDuration = {
        "WorkOrder.avg_work_order_duration_hours": "desc",
      };
      cancelledOrderCount = {
        "SOrder.cancelled_count": "desc",
      };
      cancelledOrderPercentage = {
        "SOrder.cancelled_percent": "desc",
      };
    }

    if (this.state.displayFilterValue === "workorders") {
      displayFilterDimention = [];
      displayfilterchart = "number";
      displayfilterchartHours = "number";
    } else if (this.state.displayFilterValue === "facility") {
      displayFilterDimention = ["AdOrg.facility"];
      if (this.state.facilityList.length <= 1 && (this.state.granularityList !== null || this.state.granularityList === null)) {
        displayfilterchart = "number";
      } else if (this.state.facilityList.length > 1 && this.state.granularityList === null) {
        displayfilterchart = "pie";
        displayfilterchartHours = "bar";
      } else {
        displayfilterchart = "bar";
        displayfilterchartHours = "bar";
      }

    } else if (this.state.displayFilterValue === "bay") {

      displayFilterDimention = ["FacilityLocation.location"];
      if (this.state.granularityList !== null && (this.state.facilityList.length >= 1 || this.state.productCategoryList.length >= 1)) {
        displayfilterchart = "bar";
        displayfilterchartHours = "bar";
      } else if (this.state.granularityList === null && (this.state.facilityList.length <= 1 || this.state.productCategoryList.length <= 1)) {
        displayfilterchart = "pie";
        displayfilterchartHours = "bar";
      } else {
        displayfilterchart = "pie";
      }
    } else if (this.state.displayFilterValue === "productCategory") {
      displayFilterDimention = ["ProductCategory.productCategoryName"];
      if (this.state.productCategoryList.length <= 1 && this.state.granularityList !== null) {
        displayfilterchart = "number";
      } else if (this.state.productCategoryList.length <= 1 && this.state.granularityList === null) {
        displayfilterchart = "pie";
        displayfilterchartHours = "bar";
      } else if (this.state.productCategoryList.length > 1 && this.state.granularityList === null) {
        displayfilterchart = "pie";
        displayfilterchartHours = "bar";
      } else {
        displayfilterchart = "bar";
      }
    }

    query = [
      {
        measures: ["WorkOrder.completed_count"],
        timeDimensions: timeDimentionValue,
        //timeDimensions: ,
        order: workOrderCount,
        dimensions: displayFilterDimention,
        filters: workOrderFilter,

      },
      {
        measures: ["WorkOrder.late_count"],
        timeDimensions: timeDimentionValue,
        order: workOrderLateCount,
        dimensions: displayFilterDimention,
        filters: workOrderFilter,
        limit: this.state.limitInWidget
      },
      {
        measures: ["WorkOrder.late_percent"],
        timeDimensions: timeDimentionValue,
        order: workOrderLatePercentage,
        dimensions: displayFilterDimention,
        filters: workOrderFilter,
      },
      {
        measures: ["WorkOrder.avg_work_order_lead_hours"],
        timeDimensions: timeDimentionValue,
        order: workOrderAvgSLT,
        dimensions: displayFilterDimention,
        filters: workOrderFilter,
      },

      {
        measures: ["WorkOrder.avg_work_order_duration_hours"],
        timeDimensions: timeDimentionValue,
        order: workOrderAvgDuration,
        dimensions: displayFilterDimention,
        filters: workOrderFilter,
      },

      {
        measures: ["SOrder.cancelled_count"],
        timeDimensions: timeDimentionValueForSO,
        order: cancelledOrderCount,
        dimensions: displayFilterDimention,
        filters: salesOrderFilter,
      },

      {
        measures: ["SOrder.cancelled_percent"],
        timeDimensions: timeDimentionValueForSO,
        order: cancelledOrderPercentage,
        dimensions: displayFilterDimention,
        filters: salesOrderFilter,
      },
    ];

    const DashboardItems = [
      {
        id: 1,
        grid: 12,
        name: displayfiltername,
        vizState: {
          query: query[0],
          chartType: displayfilterchart,
        },
      },
      {
        id: 2,
        grid: 12,
        name: "No of Late Work Orders",
        vizState: {
          query: query[1],
          chartType: displayfilterchart,
        },
      },
      {
        id: 3,
        grid: 12,
        name: "% of Late Work Orders",
        vizState: {
          query: query[2],
          chartType: displayfilterchart,
        },
      },
      {
        id: 4,
        grid: 12,
        name: "Average Work Order System Lead Time (HH:Mi:SS)",
        vizState: {
          query: query[3],
          chartType: displayfilterchartHours,
        },
      },
      {
        id: 5,
        grid: 12,
        name: "Average Work Order Duration (HH:Mi:SS)",
        vizState: {
          query: query[4],
          chartType: displayfilterchartHours,
        },
      }
      ,
      {
        id: 6,
        grid: 12,
        name: "No of Cancelled Sales Orders",
        vizState: {
          query: query[5],
          chartType: displayfilterchart,
        },
      },
      {
        id: 7,
        grid: 12,
        name: "% Cancelled Sales Orders",
        vizState: {
          query: query[6],
          chartType: displayfilterchart,
        },
      },
    ];


    // console.log('query[1]', query[1]);

    const dashboardItem = (item) => (<Col span={24} lg={item.grid} md={24} sm={24} xs={24} key={item.id} style={{ marginBottom: "24px", }}>
      {/* <div className="bg-with-spacing color-1"> */}
      <DashboardItem title={item.name}>
        <ChartRenderer vizState={item.vizState} />
      </DashboardItem>
      {/* </div> */}
    </Col>
    );
    return DashboardItems.length ? (
      <Dashboard>
        <ToastContainer />
        <span className="save-funnel" onClick={this.showHideOverAllFilters}>
          <FilterOutlined />
        </span>
        {this.state.showHideOverAllFilters && (
          <div>
            <span className={"save-view " + (this.state.showCreateSavedView ? 'active' : 'in-active')}
              onClick={this.showHide}>
              <Tooltip title="Saved Views">
                <Button shape="circle" className='btn-icon' icon={<SaveOutlined />} />
              </Tooltip>
            </span>
            <span className="display-view" onClick={this.showHideFilters}>
              {/* <SearchOutlined /> */}
              <Tooltip title="Filters">
                <Button shape="circle" className='btn-icon' icon={<SearchOutlined />} />
              </Tooltip>
              {" "}
            </span>
            <div className="savedViewActionBtn">
              <button className="savedView" onClick={this.showHideLabel} style={{ marginTop: "15px", }} > Save filters </button>
            </div>
          </div>
        )}
        {this.state.showSavedViews && (
          <Grid container spacing={3} style={{ padding: 30 }} alignItems="flex-start" id="filterContainer">

            <Col span={24} lg={24} xs={24} sm={24} md={24} style={{ marginBottom: "4px", }}  >
              <h1> Saved Views </h1>
            </Col>
            {console.log('this.state.storedFilters.length', this.state.storedFilters.length)}
            {this.state.storedFilters !== null && this.state.storedFilters.length > 0 ? (
              this.state.storedFilters.map((value, index) =>
                this.state.storedFilters[index] !== null ? (
                  this.state.storedFilters[index] !== "" ? (
                    <Col className='saved-filter-card' key={this.state.storedFilters[index].filterId} span={24} lg={4} style={{ marginBottom: "10px", marginRight: "0px", marginleft: "0px", }}>
                      <Card
                        actions={[
                          <Tooltip title="View">
                            <EyeOutlined key="setting" onClick={() => this.displayStateView(index)} />
                          </Tooltip>,
                          <Tooltip title="Edit"> <EditOutlined key="edit" onClick={() => this.editStateView(index, this.state.storedFilters[index].filterId)} /> </Tooltip>,
                          <Tooltip title="Delete"> <DeleteOutlined key="ellipsis" onClick={() => this.deleteStateView(index, this.state.storedFilters[index].filterId)} /> </Tooltip>,
                        ]}
                      > <Meta
                          title={this.state.storedFilters[index].name}
                          description={this.state.storedFilters[index].value}
                        />
                      </Card>
                    </Col>
                  ) : (
                      <Col span={24} lg={8} style={{ marginBottom: "24px", }}>
                        <button type="button" key={index} className="viewsList" value={index} onClick={() => this.displayStateView(index)}>
                          {"Load View " + (index + 1)}
                        </button>
                      </Col>
                    )
                ) : (
                    <h3 className='full-width'><center> No Saved Items To Display </center></h3>
                  )
              )
            ) : (
                <h3 className='full-width'><center>No Saved Items To Display</center></h3>
              )}

          </Grid>

        )}




        {this.state.showFilters && this.state.showHideOverAllFilters && (
          <div className='full-width'>
            <Grid container spacing={3} style={{ padding: 30 }} justify="space-around" alignItems="flex-start" id="filterContainer-title">
              <Col span={24} lg={4} xs={24} sm={24} md={24} style={{ marginBottom: "4px", }}   >
                <h1> {this.state.filtersTitleName} </h1>
              </Col>

              <Col span={24} lg={20} xs={24} sm={24} md={24} style={{ marginBottom: "4px", }}   >
                <Radio.Group className="filter-by-group" value={this.state.selectFilterValue} onChange={this.handleFilterOption}>
                  <Radio.Button className='bg-1' value="all">All</Radio.Button>
                  <Radio.Button className='bg-2' value="facility">Facility</Radio.Button>
                  <Radio.Button className='bg-3' value="Bpcategory">Bpcategory</Radio.Button>
                  <Radio.Button className='bg-3' value="CustomerName"> Customer name </Radio.Button>
                  <Radio.Button className='bg-3' value="lineOfBusiness">Line of business</Radio.Button>
                  <Radio.Button className='bg-3' value="productCategory">Product category</Radio.Button>
                  <Radio.Button className='bg-3' value="documentType">document type</Radio.Button>
                  <Radio.Button className='bg-3' value="servicePlan">service plan</Radio.Button>
                </Radio.Group>
              </Col>

            </Grid>
            <Grid container spacing={3} style={{ padding: 30 }} justify="space-around" alignItems="flex-start" id="filterContainer-title">
              <Col span={24} lg={24} xs={24} sm={24} md={24} style={{ marginBottom: "4px", }}   >
                <div className="filter-bg color-1">
                  <Multiselect
                    options={this.state.objectAllFilterArray}
                    selectedValues={this.state.selectedAllValue}
                    displayValue="name"
                    groupBy="catName"
                    onSelect={this.onSelectAllOption} // Function will trigger on select event
                    onRemove={this.onRemoveAllOption} // Function will trigger on remove event
                    placeholder="Select filters"
                  />
                </div>
              </Col>
            </Grid>
            <Grid container spacing={3} style={{ padding: 30 }} alignItems="flex-start" id="filterContainer-facility">
              <Col span={10} lg={11} xs={24} style={{ marginBottom: "24px", }} >
                <div className="color-11 cus-ui-radio">

                  <h3 className='sec-title mb-20'>Group By </h3>

                  {/* <FormControl component="fieldset">
                    <RadioGroup aria-label="type" name="charttype" value={this.state.displayFilterValue} onChange={this.handleChartFilter} row >
                      <FormControlLabel value="workorders" control={<Radio />} label="None" selected />
                      <FormControlLabel value="facility" control={<Radio />} label="Facility" />
                      <FormControlLabel value="productCategory" control={<Radio />} label="Product Category" />
                      <FormControlLabel value="bay" control={<Radio />} label="Bay" />
                    </RadioGroup>
                  </FormControl> */}

                  <Radio.Group className="display-by-group" value={this.state.displayFilterValue} onChange={this.handleChartFilter}>
                    <Radio.Button className='bg-1' value="workorders">None</Radio.Button>
                    <Radio.Button className='bg-2' value="facility">Facility</Radio.Button>
                    <Radio.Button className='bg-3' value="productCategory">Product Category</Radio.Button>
                    <Radio.Button className='bg-4' value="bay">Bay</Radio.Button>
                  </Radio.Group>


                  {/* <FormControl component="fieldset">
                  <Radio.Group>
                    <Radio.Button value="Today">Today</Radio.Button>
                    <Radio.Button value="This week">This week</Radio.Button>
                    <Radio.Button value="This month">This month</Radio.Button>
                    <Radio.Button value="This quarter">This quarter</Radio.Button>
                    <Radio.Button value="This year">This year</Radio.Button>
                    <Radio.Button value={undefined}>All time</Radio.Button>
                  </Radio.Group>
                  </FormControl> */}




                </div>
              </Col>
              <Col span={12} lg={4} xs={24} className="time-filter" style={{ marginBottom: "0px", }}>
                <div className="color-10 dateRange custom-ui">
                  <h3 className='sec-title'> Date Range </h3>
                  <Multiselect
                    options={this.state.optionsForDateRange} // Options to display in the dropdown
                    selectedValues={this.state.selectedDateRangeList} // Preselected value to persist in dropdown
                    onSelect={this.onSelectDateRange} // Function will trigger on select event
                    onRemove={this.onRemoveDateRange} // Function will trigger on remove event
                    singleSelect={true}
                    placeholder="FOR"
                    displayValue="name" // Property name to display in the dropdown options
                    style={this.style}
                  />
                  <div className="clearFix"></div>
                </div>
              </Col>
              <Col span={5} lg={4} xs={24} className="time-filter" style={{ marginBottom: "0px", }}>
                <div className="color-11 timeSlice custom-ui">
                  <h3 className='sec-title'> Time Slice </h3>
                  <Multiselect
                    options={this.state.optionsForGranularityList} // Options to display in the dropdown
                    selectedValues={this.state.selectedGranularityList} // Preselected value to persist in dropdown
                    onSelect={this.onSelectGranularity} // Function will trigger on select event
                    onRemove={this.onRemoveGranularity} // Function will trigger on remove event
                    singleSelect="true"
                    hidePlaceholder="true"
                    placeholder="FOR"
                    displayValue="name" // Property name to display in the dropdown options
                    style={this.style}
                  />
                  <div className="clearFix"></div>
                </div>
              </Col>
            </Grid>
            <Grid container spacing={3} style={{ paddingLeft: "30px", paddingRight: "30px", paddingTop: "-20px", paddingBottom: "-20px", }} alignItems="flex-start">
              {/* <button className="savedView" onClick={this.showHideLabel} style={{ marginTop: "15px", }} > Save Filters </button> */}
              {this.state.showCreateSavedView && (
                <Col span={6} lg={6} xs={24} style={{ marginBottom: "-12px", marginTop: "-12px", }}>
                  <div>
                    {" "}
                    <Modal visible={this.state.visible} title="Save Filter" onOk={this.handleOk} onCancel={this.handleCancel} footer={[<Button key="submit" type="primary" loading={this.loading} onClick={this.handleStateView(this.state.editMode, this.state.filterId)} >  Save </Button>,]}
                    >
                      {/* {console.log('this.state.editMode', this.state.editMode)} */}
                      {this.state.editMode ? (
                        <div>
                          <TextField id="outlined-basic" label="Filter Name" variant="outlined" name='filterName' onChange={this.handleTextInput('filterName')} style={{
                            marginTop: "10px",
                          }} value={this.state.filterName} />
                          <TextField id="filterDescription" label="Filter Description" name='filterDescription' multiline rows={4} variant="outlined" style={{ marginTop: "10px", }}
                            onChange={this.handleTextInput('filterDescription')} value={this.state.filterDescription}
                          />

                        </div>
                      ) : (
                          <div>
                            <TextField id="outlined-basic" label="Filter Name" variant="outlined" name='filterName' onChange={this.handleTextInput('filterName')} style={{
                              marginTop: "10px",
                            }} value={this.state.filterName} />
                            <TextField id="filterDescription" label="Filter Description" name='filterDescription' multiline rows={4} variant="outlined" style={{ marginTop: "10px", }}
                              onChange={this.handleTextInput('filterDescription')} value={this.state.filterDescription}
                            />
                          </div>
                        )
                      }
                      <div className='clearFix'></div>
                      <br />
                    </Modal>
                  </div>
                </Col>
              )}
            </Grid>
          </div>
        )}
        <Tour
          steps={steps}
          isOpen={this.state.isTourOpen}
          onRequestClose={this.closeTour}
          lastStepNextButton={<p>Done! Let's start playing</p>}
        />
        <Grid container spacing={3} style={{ padding: 30 }} alignItems="flex-start" key=''> {DashboardItems.map(dashboardItem)} </Grid>  </Dashboard >
    ) : (
        <div style={{ textAlign: "center", padding: 12, }}>
          <Typography variant="h5" color="inherit">
            There are no charts on this dashboard. Use Playground Build to add
            one.
        </Typography>
        </div>
      );
  }
}

export default DashboardPage;
